(() => {
  function initialiseForm(form) {
    if (form.dataset.iaSmsInitialised) return;
    const checkbox = form.querySelector('[data-ia-sms-checkbox]');
    const phone = form.querySelector('input[type="tel"]');
    const timestamp = form.querySelector('[data-ia-submission-time]');
    if (!checkbox || !phone) return;
    form.dataset.iaSmsInitialised = 'true';
    const originallyRequired = phone.required;

    function validatePhone() {
      phone.required = originallyRequired || checkbox.checked;
      const digits = phone.value.replace(/\D/g, '');
      const invalidFormat = !/^\+?[\d\s().-]+$/.test(phone.value.trim());
      const invalid = checkbox.checked && (digits.length < 10 || digits.length > 15 || invalidFormat);
      phone.setCustomValidity(invalid ? phone.dataset.iaSmsPhoneError : '');
    }

    checkbox.addEventListener('change', validatePhone);
    phone.addEventListener('input', validatePhone);
    form.addEventListener('submit', (event) => {
      validatePhone();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      if (timestamp) timestamp.value = new Date().toISOString();
    });
    validatePhone();
  }

  function initialiseForms(root) {
    if (root.matches && root.matches('form')) initialiseForm(root);
    root.querySelectorAll('form').forEach(initialiseForm);
  }

  initialiseForms(document);
  document.addEventListener('shopify:section:load', (event) => initialiseForms(event.target));
})();
